import {Layout} from '../../src/Layout';
export default Layout;

import docs from 'docs:react-aria-components';
import {Switch as VanillaSwitch} from 'vanilla-starter/Switch';
import {Switch as TailwindSwitch} from 'tailwind-starter/Switch';
import '../../tailwind/tailwind.css';
import Anatomy from '@react-aria/switch/docs/anatomy.svg';

# Switch

<PageDescription>{docs.exports.Switch.description}</PageDescription>

<ExampleSwitcher>
  <VisualExample
    component={VanillaSwitch}
    docs={docs.exports.Switch}
    links={docs.links}
    props={['children', 'isDisabled']}
    initialProps={{children: 'Low power mode'}}
    type="vanilla"
    files={["starters/docs/src/Switch.tsx", "starters/docs/src/Switch.css", "starters/docs/src/theme.css"]} />
  <VisualExample
    component={TailwindSwitch}
    docs={docs.exports.Switch}
    links={docs.links}
    props={['children', 'isDisabled']}
    initialProps={{children: 'Low power mode'}}
    type="tailwind"
    files={["starters/tailwind/src/Switch.tsx", "starters/tailwind/src/index.css"]} />
</ExampleSwitcher>

## Anatomy

<Anatomy />

A switch consists of a visual selection indicator and a label. Users may click, touch, or use the <Keyboard>Space</Keyboard> key to toggle it.

In most cases, switches should have a visual label. If a switch does not have a visible label, an `aria-label` or `aria-labelledby` prop must be provided to identify it to assistive technology.

```tsx
import {Switch} from 'react-aria-components';

<Switch>Label</Switch>
```

## Selection

Use the `isSelected` or `defaultSelected` prop to set the selection state, and `onChange` to handle selection changes.

```tsx render
"use client";
import {Switch} from 'vanilla-starter/Switch';
import {useState} from 'react';

function Example(props) {
  let [selected, setSelection] = useState(false);

  return (
    <>
      <Switch 
        {...props}
        ///- begin highlight -///
        isSelected={selected}
        onChange={setSelection}
        ///- end highlight -///
      >
        Low power mode
      </Switch>
      <p>{selected ? 'Low' : 'High'} power mode active.</p>
    </>
  );
}
```

## Forms

Use the `name` and `value` props to submit the switch to the server. See the Forms guide to learn more.

```tsx render
"use client";
import {Switch} from 'vanilla-starter/Switch';
import {Button} from 'vanilla-starter/Button';
import {Form} from 'react-aria-components';

<Form>
  {/*- begin highlight -*/}
  <Switch name="wifi">
    {/*- end highlight -*/}
    Wi-Fi
  </Switch>
  <Button type="submit" style={{marginTop: 8}}>Submit</Button>
</Form>
```

## API

<PropTable component={docs.exports.Switch} links={docs.links} showDescription />

<StateTable defaultClassName="react-aria-Switch" properties={docs.exports.SwitchRenderProps.properties} />
